/**
 * Only allow same-app relative redirect targets (no open redirects).
 * @param {unknown} value
 * @returns {string}
 */
export function safeRedirect(value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return '/';
  if (value.startsWith('/login') || value.startsWith('/two-factor-challenge')) return '/';
  return value;
}

/** @param {Record<string, unknown>} search */
export function redirectSearch(search) {
  return { redirect: typeof search.redirect === 'string' ? search.redirect : undefined };
}
